import { LivenessSceneEnum } from '@/enums/liveness-param';

export enum userActionTypeEnum {
  Liveness = 'Liveness', // 活体
  IndexVisit = 'IndexVisit', // 首页访问
}


export interface userActionCallBackParamsTypes {
  scene?: LivenessSceneEnum;
  userAction?: userActionTypeEnum;
}
